import camelCase from 'lodash/camelCase'
import startCase from 'lodash/startCase'

export enum WeatherSources {
  Tempest = 'tempest',
  OpenWeather = 'openweather',
  Mrms = 'mrms',
  OpenMeteo = 'openmeteo',
}

// display names that the default startCase(camelCase(key)) formatting gets wrong
export const weatherSourceLabels: Partial<Record<WeatherSources, string>> = {
  [WeatherSources.Mrms]: 'NOAA MRMS',
  [WeatherSources.OpenMeteo]: 'Open-Meteo',
}

// single display formatter so the form dropdown, search grid, and detail views
// all label sources the same way
export const formatWeatherSourceLabel = (weatherSource?: WeatherSources | string): string => {
  if (!weatherSource) {
    return ''
  }
  return weatherSourceLabels[weatherSource as WeatherSources] || startCase(camelCase(weatherSource))
}
